<template>
    <div>
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark"><i class="nav-icon fas fa-tools"></i> Configurações <small>Formulário de Cadastro</small></h1>
                    </div>
                    <!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/dashboard">
                                    <i class="nav-icon fas fa-home"></i> Home
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active"><i class="nav-icon fas fa-tools"></i> Configurações</li>
                        </ol>
                    </div>
                    <!-- /.col -->
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="card card-primary card-outline">
                    <form id="form1" class="form-horizontal">
                        <div class="card-header">
                            <h3 class="card-title">Dados da Configuração</h3>
                        </div>
                        <div class="card-body">
                            <div class="col-xs-12 col-sm-12 col-lg-6">
                                <div class="form-group row">
                                    <label for="codigo" class="col-sm-2 col-form-label">Código</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control validate[required]" id="codigo" name="codigo" v-model="entity.codigo" size="50" maxlength="150" placeholder="Codigo" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="descricao" class="col-sm-2 col-form-label">Descrição</label>
                                    <div class="col-sm-10">
                                        <input type="text" class="form-control validate[required]" id="descricao" name="descricao" v-model="entity.descricao" size="50" maxlength="500" placeholder="Descricao" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-lg-12">
                                <h4>Configuração</h4>
                                <div class="form-group row">
                                    <div class="col-sm-12">
                                        <code-editor v-model="entity.valor" language="html"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="card-footer">
                        <div class="offset-sm-1 col-sm-11">
                            <button type="button" v-if="this.$route.params.id == 0" v-on:click="insertEntity" class="btn btn-success btn-social"> <i class="fas fa-check"></i> Inserir</button>
                            <button type="button" v-if="this.$route.params.id != 0" v-on:click="updateEntity" class="btn btn-info btn-social"> <i class="fas fa-pencil-alt"></i> Alterar</button>
                            <button type="button" v-if="this.$route.params.id != 0" v-on:click="deleteEntity" class="btn btn-danger btn-social"> <i class="fas fa-times"></i> Excluir</button>
                            <button type="button" v-on:click="back" class="btn btn-default btn-social"><i class="fas fa-history"></i> Voltar</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>
        <!-- /.content -->
    </div>
</template>

<script>
    import ConfiguracaoController from "@/controllers/configuracao.controller";

    export default {
        data: function () {
            return {
                entity: {}
            };
        },
        mounted() {
            this.$validator.validate("#form1");
            const id = parseInt(this.$route.params.id, 10);
            this.loadEntity(id);
            $(":input").inputmask();
        },
        methods: {
            loadEntity: function (id) {

                if (id === 0)
                    return;

                ConfiguracaoController.getById(id)
                    .then(response => {
                        this.entity = response.data.result;
                    });
            },
            insertEntity: function (event) {
                if (!this.$validator.isValid("#form1"))
                return;

                event.target.disabled = true;

                let vm = this;

                ConfiguracaoController.insert(vm.entity)
                    .then(response => {
                        if (!response.data.success) {
                            vm.$toastr.error(response.data.error, 'Erro!', {
                                timeOut: 8000,
                                onHidden: function () {
                                    event.target.disabled = false;
                                }
                            });
                            return;
                        }

                        vm.$toastr.success("Dados cadastrados com sucesso.", "Aviso",
                            {
                                onHidden: function () {
                                    event.target.disabled = false;
                                    vm.back();
                                }
                            }
                        );
                    })
                    .catch(e => {
                        event.target.disabled = false;
                        vm.$toastr.error(e, 'Erro!', { timeOut: 8000 });
                    });
            },
            updateEntity: function (event) {
                if (!this.$validator.isValid("#form1"))
                return;

                event.target.disabled = true;

                let vm = this;

                ConfiguracaoController.update(vm.entity)
                    .then(response => {
                        if (!response.data.success) {
                            vm.$toastr.error(response.data.error, 'Erro!', {
                                timeOut: 8000,
                                onHidden: function () {
                                    event.target.disabled = false;
                                }
                            });
                            return;
                        }

                        vm.$toastr.success("Dados alterados com sucesso.", "Aviso",
                            {
                                onHidden: function () {
                                    event.target.disabled = false;
                                    vm.back();
                                }
                            });
                    })
                    .catch(e => {
                        event.target.disabled = false;
                        vm.$toastr.error(e, 'Erro!', { timeOut: 8000 });
                    });
            },
            deleteEntity: function (event) {
                event.target.disabled = true;

                let vm = this;

                vm.$dialogs.confirm({
                    title: 'Confirmar Exclusão!',
                    content: 'Deseja realmente excluir estes dados?',
                    icon: 'fa fa-exclamation-triangle ',
                    type: 'red',
                    buttons: {
                        confirm: {
                            text: 'Confirmar',
                            btnClass: 'btn-red',
                            action: function () {
                                event.target.disabled = true;

                                ConfiguracaoController.delete(vm.entity)
                                    .then(response => {

                                        if (!response.data.success) {
                                            vm.$toastr.error(response.data.error, 'Erro!', {
                                                timeOut: 8000,
                                                onHidden: function () {
                                                    event.target.disabled = false;
                                                }
                                            });
                                            return;
                                        }

                                        vm.$toastr.success("Dados excluídos com sucesso.", "Aviso",
                                            {
                                                onHidden: function () {
                                                    vm.back();
                                                }
                                            }
                                        );
                                    })
                                    .catch(e => {
                                        vm.$toastr.error(e, 'Erro!', { timeOut: 8000 });
                                        event.target.disabled = false;
                                    });
                            }
                        },
                        close: {
                            text: 'Cancelar'
                        }
                    }
                });
                event.target.disabled = false;
            },
            back: function () {
                this.$router.push({ name: "list-configuracao" });
            }
        }
    };
</script>

<style scoped>
</style>